import { useTranslation } from 'react-i18next'
import { PrometheusAlert, RuuviTag, RuuviTagCondition } from '../types'
import { AlertRuleName } from '../enums'
import RuuviTagStats from './RuuviTagStats'
import { translateAlertRuleName } from '../utils/alert'

interface RuuviTagDewPointStatsProps {
  ruuviTag: RuuviTag
  ruuviTagCondition: RuuviTagCondition | null
  alerts?: PrometheusAlert[]
  loading?: boolean
}

export default function RuuviTagDewPointStats({
  ruuviTag,
  ruuviTagCondition,
  alerts = [],
  loading = false
}: RuuviTagDewPointStatsProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * Indicates if there is an active dew point alert.
   */
  const isDewPointAlerting = alerts.some(
    (alert) => alert.labels.alertname === AlertRuleName.DEW_POINT
  )

  return (
    <RuuviTagStats
      ruuviTag={ruuviTag}
      title={t('dewPoint')}
      value={ruuviTagCondition?.dewPointAvg}
      unit="°C"
      date={ruuviTagCondition?.time}
      loading={loading}
      alerting={isDewPointAlerting}
      alertText={translateAlertRuleName(AlertRuleName.DEW_POINT)}
    />
  )
}
